<template>
  <div
    v-if="menuItems.length > 0"
    class="lg:h-full"
  >
    <DesktopSidebar
      :menu-items="menuItems"
      :footer-menu-items="footerMenuItems"
    />
    <MobileSidebar
      :menu-items="menuItems"
    />
  </div>
</template>
<script>
import DesktopSidebar from './desktop';
import MobileSidebar from './mobile';
import { getMenuItems, getFooterMenuItems } from './get-sidebar-data';

export default {
  components: {
    DesktopSidebar,
    MobileSidebar,
  },
  data() {
    return {
      menuItems: [],
      footerMenuItems: [],
    };
  },
  async beforeMount() {
    this.menuItems = await getMenuItems(this.$store.getters.userType);
    this.footerMenuItems = await getFooterMenuItems();
  },
};
</script>
